export const MENU_CATEGORY_ICON_SIZE = '[256,256]';
export const RULE_ICON_SIZE = '[50,50]';
